import DomElementsBase from "@grindex-common/abstracts/DomElementsBase.class";

const ID_PREVIEW_SLIDER = "#bxslider";
const ID_THUMBNAIL_SLIDER = "#bxslider-pager";
const SELECTOR_PREVIEW_WRAPPER = ".preview-slider .bx-wrapper";
const SELECTOR_THUMBNAIL_WRAPPER = ".thumbnail-slider .bx-wrapper";
const SELECTOR_BTN_PREV = ".bx-prev";
const SELECTOR_BTN_NEXT = ".bx-next";
const CLASS_SELECTED = "selected";

export default class ImageCarouselDomElements extends DomElementsBase {
	constructor($module) {
		const selectors = [SELECTOR_THUMBNAIL_WRAPPER, SELECTOR_PREVIEW_WRAPPER, SELECTOR_BTN_PREV, SELECTOR_BTN_NEXT, ID_PREVIEW_SLIDER, ID_THUMBNAIL_SLIDER];

		super($module, selectors);

		this.elements = {
			previousButtonElement: () => {
				return this.getElement(SELECTOR_BTN_PREV);
			},

			nextButtonElement: () => {
				return this.getElement(SELECTOR_BTN_NEXT);
			},

			thumbnailWrapperElement: () => {
				return this.getElement(SELECTOR_THUMBNAIL_WRAPPER);
			},

			previewWrapperElement: () => {
				return this.getElement(SELECTOR_PREVIEW_WRAPPER);
			},

			previewSliderElement: () => {
				return this.getElement(ID_PREVIEW_SLIDER);
			},

			thumbnailSliderElement: () => {
				return this.getElement(ID_THUMBNAIL_SLIDER);
			},

			thumbnailSliderLinkElements: () => {
				return this.elements.thumbnailSliderElement().getElementsByTagName("a");
			},

			previewSliderImageElements: () => {
				return this.elements.previewSliderElement().getElementsByTagName("img");
			},

			thumbnailSliderListElements: () => {
				if (!this.$thumbnailSliderListElements) {
					this.$thumbnailSliderListElements = this.getChildrenByTag(ID_THUMBNAIL_SLIDER, "li");
				}

				return this.$thumbnailSliderListElements;
			},
		};
	}

	getPreviewSlider(config) {
		return $(this.elements.previewSliderElement()).bxSlider(config);
	}

	getThumbnailSlider(config) {
		if (!this.$thumbnailSlider) {
			const thumbnailElement = this.elements.thumbnailSliderElement();
			this.$thumbnailSlider = $(thumbnailElement).bxSlider(config);
		}

		return this.$thumbnailSlider;
	}

	resetThumbnailSlider() {
		if (this.$thumbnailSlider) {
			this.$thumbnailSlider.destroySlider();
		}
	}

	getSlideIndex($element) {
		return $element ? $element.dataset.slideindex : 0;
	}

	getThumbnailSlidesWidth() {
		const thumbnailElement = this.elements.thumbnailSliderElement();

		return thumbnailElement ? thumbnailElement.dataset.slideWidth : 0;
	}

	getThumbnailSlideCount() {
		const thumbnailElement = this.elements.thumbnailSliderElement();

		return thumbnailElement ? thumbnailElement.dataset.slideCount : 0;
	}

	unselectAllPagerSliderListElementsExcept(index) {
		const $listElements = this.elements.thumbnailSliderListElements();

		$listElements.forEach(($listElement) => {
			$listElement.classList.remove(CLASS_SELECTED);

			if ($listElement.dataset.slideindex === index) {
				$listElement.classList.add(CLASS_SELECTED);
			}
		});
	}
}
